import * as ActionTypes from "../Actions/ActionTypes";
import { updateObject } from "../Utility";

const initialState = {
  prematchSportID: 2, // soccer
  liveSportID: 1,
  calendarItemID: 1,
  mostPlayedButtonID: 1, //najtipovaniji default
  categoryID: 0,
  leagueID: 0,
  liveExtraBetsID: -1,
  prematchExtraBetsID: -1,
  activeBetGroups: "",
  shouldQuickCloseExtraBets: false,
  currentTicketNumber: -1,
  currentPayoutReceiptNumber: -1,
  canShowExtraBetsLive: true,
  canShowExtraBetsPrematch: true,
  currentActionButton: 0,
  matchForStatisticsID: 0,
  isShowingBonusInfo: false,
  isShowingSystemCombinations: false,
  currentAdminScreenID: 1,
  isAdminLoggedIn: false,
  adminInfo: { UserToken: "", Username: "" },
  isAdminLoadingShown: false,
  chosenDate: new Date(),
  lastUsedPickerID: 1 //calendar po defaults
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.NAVIGATION_CHANGE_ADMIN_LOADING_INDICATOR:
      return updateObject(state, { isAdminLoadingShown: action.isLoading });
    case ActionTypes.NAVIGATION_CHANGE_ADMIN_LOGIN_STATE:
      return updateObject(state, { isAdminLoggedIn: action.isLoggedIn });
    case ActionTypes.NAVIGATION_SET_ADMIN_INFO:
      return updateObject(state, { adminInfo: action.info });
    case ActionTypes.NAVIGATION_CHANGE_SPORT_PREMATCH:
      return updateObject(state, { prematchSportID: action.sportID });
    case ActionTypes.NAVIGATION_CHANGE_LAST_USED_PICKER:
      return updateObject(state, { lastUsedPickerID: action.pickerID });
    case ActionTypes.NAVIGATION_SET_MATCH_FOR_STATISTICS_ID:
      return updateObject(state, { matchForStatisticsID: action.matchID });
    case ActionTypes.NAVIGATION_SET_PAYOUT_RECEIPT_NUMBER_FOR_DETAILS:
      return updateObject(state, {
        currentPayoutReceiptNumber: action.receiptNumber
      });
    case ActionTypes.NAVIGATION_CHANGE_CURRENT_ADMIN_SCREEN:
      return updateObject(state, { currentAdminScreenID: action.screenID });
    case ActionTypes.NAVIGATION_CHANGE_SPORT_LIVE:
      return updateObject(state, { liveSportID: action.sportID });
    case ActionTypes.NAVIGATION_CHANGE_CALENDAR_ITEM:
      return updateObject(state, {
        calendarItemID: action.calendarItemID,
        chosenDate: action.chosenDate
      });
    case ActionTypes.NAVIGATION_CHANGE_MOST_PLAYED_BUTTON:
      return updateObject(state, {
        mostPlayedButtonID: action.mostPlayedButtonID
      });
    case ActionTypes.NAVIGATION_CHANGE_COUNTRY:
      return updateObject(state, {
        categoryID: action.categoryID
      });
    case ActionTypes.NAVIGATION_CHANGE_LEAGUE:
      return updateObject(state, {
        leagueID: action.leagueID
      });
    case ActionTypes.NAVIGATION_CHANGE_CURRENT_LIVE_EXTRA_BETS_ID:
      return updateObject(state, { liveExtraBetsID: action.betsID });
    case ActionTypes.NAVIGATION_CHANGE_CURRENT_PREMATCH_EXTRA_BETS_ID:
      return updateObject(state, { prematchExtraBetsID: action.betsID });
    case ActionTypes.NAVIGATION_CHANGE_CURRENT_BET_GROUPS:
      return updateObject(state, { activeBetGroups: action.betGroups });
    case ActionTypes.NAVIGATION_SET_TICKET_FOR_DETAILS:
      return updateObject(state, { currentTicketNumber: action.ticketNumber });
    case ActionTypes.NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_LIVE:
      return updateObject(state, { canShowExtraBetsLive: action.canShow });
    case ActionTypes.NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_PREMATCH:
      return updateObject(state, { canShowExtraBetsPrematch: action.canShow });
    case ActionTypes.NAVIGATION_SET_SHOULD_QUICK_CLOSE_EXTRA_BETS:
      return updateObject(state, {
        shouldQuickCloseExtraBets: action.shouldClose
      });
    case ActionTypes.NAVIGATION_SET_TERMINAL_ACTIONS_ACTIVE_BUTTON:
      return updateObject(state, {
        currentActionButton: action.activeAction
      });
    case ActionTypes.NAVIGATION_SET_IS_SHOWING_BONUS_INFO:
      return updateObject(state, {
        isShowingBonusInfo: action.showsBonus
      });
    case ActionTypes.NAVIGATION_SET_IS_SHOWING_SYSTEM_INFO:
      return updateObject(state, {
        isShowingSystemCombinations: action.showSystemInfo
      });
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/ReduxStore/Reducers/NavigationReducer.js